
import { defineComponent, onMounted, reactive, ref } from 'vue';
import PageModel4 from '@/components/page-model4/index.vue';
import { useStore } from 'vuex';
import { debounce } from 'lodash-es';
import { useRoute } from 'vue-router';
import moment from 'moment';

export default defineComponent({
  setup() {
    const store = useStore();
    const route = useRoute();
    const current_org = store.getters['user/current_org'];
    const search = reactive({
      current: 1,
      pageSize: 2000,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        org_id: current_org.id,
        is_search: true,
        is_active: 'true',
      },
    });
    const treeMode: any = ref('radio');
    const loading: any = ref(true);
    const tableHeight = reactive({ y: window.innerHeight - 110, y2: window.innerHeight - 260 });
    const onresize: any = debounce(() => {
      tableHeight.y = window.innerHeight - 110;
      tableHeight.y2 = window.innerHeight - 260;
    }, 200);
    onMounted(() => {
      window.onresize = onresize;
      onresize();
    });
    const handleCancel = () => {};
    const searchObj: any = {};
    if (route.params['create_time']) {
      searchObj.create_time = [
        route.params['create_time'],
        moment().add(1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
      ];
    }
    if (route.params['request_id']) {
      searchObj.r_id = route.params['request_id'];
    }
    const group = reactive({
      title: '',
      column_flag: 'log_app-logrecordinfo',
      search: { ...search, requestParams: { ...search.requestParams, ...searchObj } },
      modalType: 'log_app-logrecordinfo',
      height: tableHeight.y,
      mode: 'null',
    });

    return {
      treeMode,
      tableHeight,
      loading,
      group,
      handleCancel,
    };
  },
  components: {
    PageModel4,
  },
});
